export const MediaServerTypes = {
    Image: 1
};
